import * as React from "react";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import FacebookProvider, { Like } from "react-facebook";

import { TextInput } from "../../../components";
import Modal from "../../../components/Modal";
import validate from "../subscription-form-validation";

import "./MarketingForm.css";
import { FACEBOOK_APPID, FACEBOOK_PAGE_URL } from "../constants";

export interface MarketingFormValues {
  source: string;
  email: string;
}

export interface MarketingFormProps {
  isOpen: boolean;
  onClose: () => void;
}

export interface AugmentedMarketingFormProps
  extends InjectedFormProps<MarketingFormValues, MarketingFormProps>,
    MarketingFormProps {}

const MarketingForm = (props: AugmentedMarketingFormProps) => (
  <Modal {...props} className="marketing-popup">
    <div className="container marketing-popup__container">
      <button type="button" className="close-btn" onClick={props.onClose}>
        <i className="fa fa-times" />
      </button>
      <div className="marketing-popup__animate" />
      <div className="marketing-popup__content">
        <p>
          Để nhận 02 CV <br /> và Mã giảm 15% mọi sản phẩm
        </p>
        <p>Like và nhập Email</p>
        <div className="marketing-popup__like-btn">
          <FacebookProvider appId={FACEBOOK_APPID}>
            <Like href={FACEBOOK_PAGE_URL} colorScheme="dark" />
          </FacebookProvider>
        </div>
        <form className="form-inline" onSubmit={props.handleSubmit}>
          <Field component="input" type="hidden" name="source" />
          <Field
            component={TextInput}
            className="form-group"
            type="email"
            name="email"
            placeholder="Email của bạn"
          />
          <Field
            component="input"
            className="form-group"
            type="hidden"
            name="campaign_token"
          />
          <button
            type="submit"
            className="marketing-popup__submit-btn"
            disabled={props.submitting}
          >
            Gửi{" "}
            {props.submitting && <i className="fa fa-fw fa-pulse fa-spinner" />}
          </button>
        </form>
      </div>
    </div>
  </Modal>
);

export default reduxForm<MarketingFormValues, MarketingFormProps>({
  form: "marketing-form",
  validate,
})(MarketingForm);



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/MarketingForm.tsx